module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "left-1"
  }, [_c('i', [_vm._v("O dance along the silver sand")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "left-2"
  }, [_c('i', [_vm._v("And beat the turtle drum")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "left-2"
  }, [_c('i', [_vm._v("That youth may last for ever")])]), _vm._v(" "), _c('p', {
    staticClass: "left-2"
  }, [_c('i', [_vm._v("And sorrow never come.")])]), _vm._v(" "), _c('p', {
    staticClass: "right001"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IAN SERRAILLIER")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495aa1af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 66
// module chunks = 0